import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid text-left" }
const _hoisted_2 = { class: "row fluid-content" }
const _hoisted_3 = { class: "text-center m-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-center m-0"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "fas fa-arrow-right mx-2"
}
const _hoisted_7 = {
  key: 0,
  class: "col-md-5 col-12 border-start resume vh-100"
}
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ticket_option_card = _resolveComponent("ticket-option-card")!
  const _component_event_ticket_resume = _resolveComponent("event-ticket-resume")!
  const _component_tickets_checkout = _resolveComponent("tickets-checkout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["col-12 p-5", _ctx.checkout ? 'col-md-3 opacity-50 disabled' : 'col-md-7']),
        id: "ticket-list"
      }, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.event?.title), 1),
        (
            _ctx.event?.date.display_start_date_time ||
            _ctx.event?.date.display_end_date_time
          )
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              (_ctx.event?.date.display_start_date_time && _ctx.event?.date.start)
                ? (_openBlock(), _createElementBlock("small", _hoisted_5, [
                    _cache[2] || (_cache[2] = _createTextVNode(" Comienza el ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.date(_ctx.event?.date.start)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.event?.date.display_end_date_time && _ctx.event?.date.end)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.event?.date.display_start_date_time)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("small", null, [
                      _cache[3] || (_cache[3] = _createTextVNode("Finaliza el ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.date(_ctx.event?.date.end)), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-center m-0" }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
        (_ctx.event && _ctx.ticket_options.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.ticket_options, (option) => {
              return (_openBlock(), _createBlock(_component_ticket_option_card, {
                event: _ctx.event,
                option: option,
                onOnChangeSelector: _ctx._changeSelector,
                key: option.id,
                disabled: _ctx.checkout
              }, null, 8, ["event", "option", "onOnChangeSelector", "disabled"]))
            }), 128))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["col-12 border-start resume vh-100", _ctx.checkout ? 'col-md-4 opacity-50 disabled' : 'col-md-5'])
      }, [
        (_ctx.event)
          ? (_openBlock(), _createBlock(_component_event_ticket_resume, {
              key: 0,
              optionSelected: _ctx.optionSelected,
              event: _ctx.event,
              disabled: _ctx.checkout
            }, null, 8, ["optionSelected", "event", "disabled"]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.checkout)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.event)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.checkout)
                    ? (_openBlock(), _createBlock(_component_tickets_checkout, {
                        key: 0,
                        "option-selected": _ctx.optionSelected,
                        event: _ctx.event
                      }, null, 8, ["option-selected", "event"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("footer", null, [
      (_ctx.checkout)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-secondary me-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCheckout && _ctx.closeCheckout(...args)))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
            _createTextVNode(" Regresar ", -1)
          ]))]))
        : _createCommentVNode("", true),
      (!_ctx.checkout)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCheckout && _ctx.openCheckout(...args))),
            disabled: _ctx.optionSelected.length == 0
          }, [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Continuar ", -1),
            _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
          ]))], 8, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}